import React from 'react';
import { Star, TrendingUp, BadgeCheck, Camera, MessageSquare, Search, Phone, Navigation, Globe, Bookmark, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
const included = [{
  icon: Camera,
  text: 'Subimos fotos de tus trabajos'
}, {
  icon: MessageSquare,
  text: 'Contestamos tus reseñas'
}, {
  icon: Search,
  text: 'Optimización para salir primero'
}];
type Profile = {
  name: string;
  category: string;
  location: string;
  rating: string;
  reviews: number;
  url: string;
  image?: string;
};
// 👉 Reemplaza con los perfiles de Google reales que manejas.
const profiles: Profile[] = [{
  name: 'Jose Junk Removal Service',
  category: 'Junk Removal',
  location: 'Florida',
  rating: '5.0',
  reviews: 48,
  url: 'https://share.google/YgRBqzQGSBTD7hIq8',
  image: 'https://cdn.magicpatterns.com/uploads/kKQ1RwEhmtKi554o7bSt5H/private_1a1e5b95-0d5f-4a6e-a505-567a124210b9.png'
}, {
  name: 'RMorales Lawn Services LLC',
  category: 'Landscaping',
  location: 'Texas',
  rating: '4.9',
  reviews: 36,
  url: 'https://share.google/S8v71YfmQV2kZIxy8',
  image: 'https://cdn.magicpatterns.com/uploads/oTAMVxe6v6TChxqDoDapyM/1111.png'
}];
export function GoogleProfilesSection() {
  return <section className="py-20 bg-dark-100 border-t border-white/5" data-id="element-115">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-117">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gold/10 border border-gold/20 mb-5" data-id="element-118">
            <TrendingUp className="w-4 h-4 text-gold" data-id="element-119" />
            <span className="text-gold text-sm font-bold tracking-wide uppercase" data-id="element-120">
              Servicio Aparte · Opcional
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-4" data-id="element-121">
            Manejo de Tu Perfil de{' '}
            <span className="text-gold" data-id="element-122">Google Business</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto mb-4" data-id="element-123">
            Este servicio es{' '}
            <strong className="text-white" data-id="element-124">independiente del website</strong> y
            tiene un costo extra de{' '}
            <strong className="text-gold" data-id="element-125">$30/mes</strong>. Nosotros nos
            encargamos de manejarlo para que aparezcas primero en tu zona y
            consigas más clientes — sin pagar publicidad.
          </p>
          <p className="text-sm text-gray-500 max-w-2xl mx-auto mb-8" data-id="element-126">
            <strong className="text-gray-300" data-id="element-127">Nota:</strong> el perfil lo crea
            el cliente. Nosotros solo nos encargamos de manejarlo y optimizarlo.
          </p>

          {/* What's included */}
          <div className="flex flex-wrap justify-center gap-3 max-w-2xl mx-auto" data-id="element-128">
            {included.map((item, i) => <div key={i} className="inline-flex items-center gap-2 bg-dark border border-white/10 rounded-full px-4 py-2 text-sm text-gray-300" data-id="element-129">
                <item.icon className="w-4 h-4 text-gold" data-id="element-130" />
                {item.text}
              </div>)}
          </div>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 items-start" data-id="element-131">
          {profiles.map((profile, index) => <motion.a key={index} href={profile.url} target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.4
        }} className="group block bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-shadow" data-id="element-132">
              {/* Photo header (like a Google profile) */}
              <div className="relative aspect-[16/9] overflow-hidden bg-gray-100" data-id="element-133">
                {profile.image ? <img src={profile.image} alt={`Perfil de Google de ${profile.name}`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-134" /> : <div className="w-full h-full flex items-center justify-center bg-gray-200" data-id="element-135">
                    <MapPin className="w-10 h-10 text-gray-400" data-id="element-136" />
                  </div>}
                <div className="absolute top-3 left-3 inline-flex items-center gap-1.5 text-xs font-bold text-green-700 bg-white/95 px-2.5 py-1 rounded-full shadow-sm" data-id="element-137">
                  <BadgeCheck className="w-3.5 h-3.5 text-green-600" data-id="element-138" />
                  Optimizado
                </div>
              </div>

              {/* Google-style info panel */}
              <div className="p-5" data-id="element-139">
                <h3 className="text-gray-900 font-medium text-xl leading-snug mb-1" data-id="element-140">
                  {profile.name}
                </h3>

                <div className="flex items-center gap-1.5 mb-1" data-id="element-141">
                  <span className="text-[#70757a] font-medium text-sm" data-id="element-142">
                    {profile.rating}
                  </span>
                  <div className="flex gap-0.5" data-id="element-143">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-[#fbbc04] text-[#fbbc04]" data-id="element-144" />)}
                  </div>
                  <span className="text-[#70757a] text-sm" data-id="element-145">
                    ({profile.reviews})
                  </span>
                </div>

                <p className="text-[#70757a] text-sm mb-4" data-id="element-146">
                  {profile.category} · {profile.location}
                </p>

                {/* Google action buttons */}
                <div className="flex items-center justify-between border-t border-gray-100 pt-4" data-id="element-147">
                  {[{
                icon: Navigation,
                label: 'Cómo llegar'
              }, {
                icon: Bookmark,
                label: 'Guardar'
              }, {
                icon: Phone,
                label: 'Llamar'
              }, {
                icon: Globe,
                label: 'Sitio web'
              }].map((action, i) => <div key={i} className="flex flex-col items-center gap-1.5 flex-1" data-id="element-148">
                      <div className="w-10 h-10 rounded-full border border-gray-300 flex items-center justify-center text-[#1a73e8]" data-id="element-149">
                        <action.icon className="w-4 h-4" data-id="element-150" />
                      </div>
                      <span className="text-[11px] text-[#1a73e8] font-medium" data-id="element-151">
                        {action.label}
                      </span>
                    </div>)}
                </div>
              </div>
            </motion.a>)}
        </div>
      </div>
    </section>;
}